var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27,
    fill: "#F1E8FF",
    stroke: "#7214FF",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_1766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7049 11.79C21.3025 11.79 16.0996 16.9931 16.0996 23.3953C16.0996 25.5616 16.6993 27.67 17.8405 29.4881L26.9182 44.3438C27.073 44.5952 27.3051 44.75 27.576 44.7887C27.9434 44.8467 28.3497 44.692 28.5624 44.3245L37.6661 29.3333C38.7491 27.5539 39.3101 25.4843 39.3101 23.3953C39.3101 16.9931 34.1072 11.79 27.7049 11.79ZM27.7049 29.1979C24.4555 29.1979 21.9022 26.5674 21.9022 23.3953C21.9022 20.2038 24.5134 17.5927 27.7049 17.5927C30.8964 17.5927 33.5075 20.2038 33.5075 23.3953C33.5075 26.5481 30.993 29.1979 27.7049 29.1979Z",
    fill: "#7214FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7048 11.79V17.5927C30.8963 17.5927 33.5075 20.2038 33.5075 23.3953C33.5075 26.5481 30.9929 29.1979 27.7048 29.1979V44.8C28.0349 44.8077 28.3743 44.6494 28.5623 44.3245L37.666 29.3333C38.7491 27.5539 39.3101 25.4843 39.3101 23.3953C39.3101 16.9931 34.1072 11.79 27.7048 11.79Z",
    fill: "#7214FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_1766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.0105,
    height: 33.0105,
    fill: "white",
    transform: "translate(11.1997 11.79)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/MapPin.2031ee3cd8a00e4370d71ea340cd1912.svg";
export { ForwardRef as ReactComponent };